









































import { User, Global, Reports, Projects } from '@/store';
import Vue from 'vue';
import Component from 'vue-class-component';
import GroupsListTable from '@/components/GroupsListTable.vue';
import API, { Types } from '@/modules/API';
import MessageDialog from '@/components/dialogs/MessageDialog.vue';
import LoadingDialog from '@/components/dialogs/LoadingDialog.vue';
import Utils from '@/modules/Utils';
import moment from 'moment-timezone';

@Component({
    components: { 
        GroupsListTable,
        MessageDialog,
        LoadingDialog
    }
})

class ChangeGroupMode extends Vue {
    @User.State('project') project;
    @Global.State('readonly_user') readonly_user;
    @Global.State('lang') lang;
    @Global.Mutation('setPageTitle') setPageTitle;
    @Reports.Getter('commissioned_map') commissioned_map;
    @Reports.Getter('commissionedFixtures') commissionedFixtures;
    @Projects.State('projects_metadata') projects_metadata;

    selectedGroups = [];
    mode = 1;
    isLoadingDialogOpen = false;
    isMessageDialogOpen = false;
    notCompleted = [];
    retrofit_skipped = 0;
    message = 'You must choose at least one item in table';

    mounted(){
        this.setPageTitle('Group Status');
    }

    get has_retrofit_devices(){
        return this.commissionedFixtures.some((device) => !Utils.isDeviceLive(device));
    }

    get groupModes(){
        return [
            { text: this.$t('Connected'), value: 1},
            { text: this.$t('Fault In Care'), value: -9}, 
            { text: this.$t('Maintenance'), value: -1}
        ];
    }

    updateSelectedGroups(selected){
        this.selectedGroups = [...selected];
    }

    async handleChangeClicked(){
        if (!this.selectedGroups.length) {
            this.isMessageDialogOpen = true;
            return;
        }
        this.isLoadingDialogOpen = true;
        this.notCompleted = []; // Reset notCompleted array for new operation
        this.retrofit_skipped = 0;

        await Promise.all(this.selectedGroups.map((group) => this.updateGroupMode(group, this.mode)));

        this.updateSelectedGroups([]);
        this.isLoadingDialogOpen = false;
        
        this.notCompleted.length ? this.notifyStatus(false) : this.notifyStatus(true);
        this.notifyRetrofitSkipped();
    }     

    async updateGroupMode(group, mode){
        let groupData = null;
        try {
            groupData = await API.get(Types.PROJECTS, `${this.project.id}/groups/${group.id}`, {}, {}, 'v4');
        } catch (e) {}

        if (!groupData){
            this.notCompleted.push(group.id);
            return;
        }
        
        let isCompleted = true;

        const slices = Math.ceil(groupData.devices.length / 100);
        let startIndex = 0, endIndex = Math.min(groupData.devices.length, 100);
        for (let i = 0; i < slices; i++){
            const current = groupData.devices.slice(startIndex, endIndex);
            await Promise.all(current.map( async (device_id) => {
                try {
                    const device_on_store = this.commissioned_map.get(device_id);
                    // A group can hold devices that are out for Retrofit - their
                    // status must stay untouched until they return.
                    if (device_on_store && !Utils.isDeviceLive(device_on_store)) {
                        this.retrofit_skipped++;
                        return;
                    }
                    // Skip API call if device status hasn't changed
                    if (device_on_store && device_on_store.sys___active === mode) {
                        return;
                    }
                    
                    const response = await this.updateDeviceMode(device_id, mode);
                    if (response.ok) {
                        if (device_on_store) {
                            this.updateDeviceModeOnStore(device_on_store);
                        }
                    }
                }catch (e){
                    isCompleted = false;
                }
            }));
            startIndex = endIndex;
            endIndex = Math.min(groupData.devices.length, endIndex + 100);
        }
        if (!isCompleted) this.notCompleted.push(group.id);
    }

    updateDeviceModeOnStore(device){
        const prev_status = Utils.getDeviceStatus(device);

        device.sys___active = this.mode;
        // Set 10-digit UTC timestamp (seconds)
        device.sys___active__modified = Math.floor(Date.now() / 1000);

        const new_status = Utils.getDeviceStatus(device);
        const activity_chart = this.projects_metadata.get(this.project.id).device_state_metrics;
        
        // Handle both old format (number) and new format (object with count and name)
        if (typeof activity_chart[prev_status] === 'object' && activity_chart[prev_status] !== null) {
            activity_chart[prev_status].count -= 1;
        } else {
            activity_chart[prev_status] -= 1;
        }
        
        if (typeof activity_chart[new_status] === 'object' && activity_chart[new_status] !== null) {
            activity_chart[new_status].count += 1;
        } else {
            activity_chart[new_status] += 1;
        }
    }

    updateDeviceMode(device_id, mode){
        return API.post('', `${Types.PROJECTS}/${this.project.id}/${Types.DEVICES}/${device_id}/streams/sys___active/evt/`, { content: mode }, {}, 'v4');
    }

    notifyRetrofitSkipped(){
        if (!this.retrofit_skipped) return;

        this.$notify({
            type: 'info',
            title: 'Devices under Retrofit',
            text: `${this.retrofit_skipped} ${this.$t('devices under Retrofit were skipped')}`
        });
    }

    notifyStatus(isCompleted){
        let notifyData;
        if (isCompleted){
            notifyData = {
                text: `All groups updated successfully!`,
                type: 'success',
                title: 'Success!'
            };
        }else{
            let groupsNotCompleted = '';
            this.notCompleted.forEach((id) => groupsNotCompleted = groupsNotCompleted + id + ', ');
            notifyData = {
                text: `Some mode devices in groups: ${groupsNotCompleted} could not update. Please try again later.`,
                type: 'error',
                title: 'Error!'
            };
        }
        
        this.$notify(notifyData);
    }
}

export default ChangeGroupMode;
